/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICustomerContact } from './APICustomerContact';
import {
    APICustomerContactFromJSON,
    APICustomerContactFromJSONTyped,
    APICustomerContactToJSON,
} from './APICustomerContact';

/**
 * 
 * @export
 * @interface APICustomerSearchResult
 */
export interface APICustomerSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APICustomerSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APICustomerSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APICustomerSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerSearchResult
     */
    ustId?: string;
    /**
     * 
     * @type {Array<APICustomerContact>}
     * @memberof APICustomerSearchResult
     */
    contacts?: Array<APICustomerContact>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APICustomerSearchResult
     */
    contactEmails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APICustomerSearchResult
     */
    contactNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APICustomerSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APICustomerSearchResult interface.
 */
export function instanceOfAPICustomerSearchResult(value: object): value is APICustomerSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APICustomerSearchResultFromJSON(json: any): APICustomerSearchResult {
    return APICustomerSearchResultFromJSONTyped(json, false);
}

export function APICustomerSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'name': json['name'],
        'ustId': json['ust_id'] == null ? undefined : json['ust_id'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(APICustomerContactFromJSON)),
        'contactEmails': json['contact_emails'] == null ? undefined : json['contact_emails'],
        'contactNames': json['contact_names'] == null ? undefined : json['contact_names'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APICustomerSearchResultToJSON(value?: APICustomerSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'name': value['name'],
        'ust_id': value['ustId'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(APICustomerContactToJSON)),
        'contact_emails': value['contactEmails'],
        'contact_names': value['contactNames'],
        'root_account_id': value['rootAccountId'],
    };
}

